import { useMemo } from "react";

import { isPreflightGated } from "@/utils/isPreflightGated";

import { useWorkspaceEntitlement } from "./useWorkspaceEntitlement";

export const usePreflightGated = (
  actionPrice: number | null | undefined,
): boolean => {
  const { entitlement } = useWorkspaceEntitlement();

  return useMemo(
    () =>
      isPreflightGated({
        actionPrice,
        entitlement,
      }),
    [actionPrice, entitlement],
  );
};
